import { inject, Injectable } from "@angular/core";
import { first, map } from "rxjs";
import { GraphService } from "@kernel/graphql/services/graph.service";
import { PRICE_LIST_FORM_QUERY } from "../queries/price-list-form.query";
import { IPriceList } from "../interfaces/price-list.interface";

/**
 * GraphQL operations for price lists. Provided on the domain route, not in root.
 * Create and update go through the form mutation configs.
 */
@Injectable()
export class PriceListApiService {
  /** GraphQL service used for executing queries. */
  private readonly graphService = inject(GraphService);

  /**
   * Fetches a price list by id or entityId.
   *
   * @param id - The price list id or entityId.
   * @param dataShape - Selection set; defaults to the form query.
   */
  getPriceList(id: string, dataShape: string | string[] = PRICE_LIST_FORM_QUERY) {
    return this.graphService.constructQuery<{ getPriceList: IPriceList }>(dataShape, "getPriceList", { id }).pipe(
      first(),
      map(data => {
        if (data.errors?.length) {
          throw data.errors[0];
        }
        return data.data.getPriceList;
      })
    );
  }
}
